type MetaPixel = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: MetaPixel;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function initGoogleAnalytics() {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (
    !import.meta.env.PROD ||
    !measurementId ||
    typeof window === 'undefined' ||
    window.gtag
  )
    return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // Google's command queue expects the function's arguments object.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

const campaignParams = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
];

export function initMetaPixel() {
  const pixelId = import.meta.env.VITE_META_PIXEL_ID;
  if (
    !import.meta.env.PROD ||
    !pixelId ||
    typeof window === 'undefined' ||
    window.fbq
  )
    return;

  const fbq: MetaPixel = (...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue!.push(args);
    }
  };
  fbq.queue = [];
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  window.fbq = fbq;
  window._fbq = window._fbq || fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
}

export function trackAirbnbClick(placement: string) {
  window.gtag?.('event', 'airbnb_outbound_click', {
    placement,
    destination: 'airbnb'
  });
  const params = new URLSearchParams(window.location.search);
  const campaign = Object.fromEntries(
    campaignParams
      .filter((key) => params.has(key))
      .map((key) => [key, params.get(key)])
  );

  window.fbq?.('trackCustom', 'AirbnbOutboundClick', {
    placement,
    destination: 'airbnb',
    ...campaign
  });
}
